import LayoutScreen from '../../components/layout';
import Button from '../../components/button';
import ButtonOutline from '../../components/buttonOutline';
import { useEffect, useState } from 'react';
import HasilAnalisaBerhasil from './hasilAnalisaBerhasil';
import HasilAnalisaGagal from './hasilAnalisaGagal';
import { useNavigate } from 'react-router-dom';
import { clearAnalisa, clearBiodata } from '../../utils/helper';
import HasilAnalisaNonFungil from './hasilAnalisaNonFungil';
import HasilAnalisaNopathologies from './hasilAnalisaNopathologies';
const PageAnalisa = (props) => {
  const navigate = useNavigate();
  const [analisaData, setAnalisaData] = useState(null);

  useEffect(() => {
    const savedData = localStorage.getItem('analisa');
    if (savedData) {
      setAnalisaData(JSON.parse(savedData));
    }
  }, []);

  const handlePeriksaLagi = () => {
    clearBiodata();
    clearAnalisa();
    navigate('/biodata');
  };

  const handleSelesai = () => {
    navigate('/');
  };

  return (
    <LayoutScreen>
      <div className="relative flex flex-col flex-grow h-full px-5 p-5 md:p-10">
        <div className="h-full flex flex-col flex-grow justify-between items-center">
          <div className=" w-full text-center w-full md:text-2xl font-semibold text-textBlack">
            <h1 className="">HASIL ANALISA </h1>
          </div>
          {analisaData != null ? (
            <>
              {analisaData.status === 'fungil' ? (
                <HasilAnalisaBerhasil analisa={analisaData} />
              ) : analisaData.status === 'nopathologies' ? (
                <HasilAnalisaNopathologies analisa={analisaData} />
              ) : (
                <HasilAnalisaNonFungil analisa={analisaData} />
              )}
            </>
          ) : (
            <HasilAnalisaGagal analisa={analisaData} />
          )}

          <div className="w-full flex flex-col justify-center items-center">
            <div
              className="w-full flex flex-col justify-center items-center
             md:flex-row space-y-4 md:space-y-0 md:space-x-4">
              <div className="flex flex-none w-full md:max-w-[200px] px-0 md:px-0">
                <ButtonOutline
                  label="Periksa Lagi"
                  onClick={() => handlePeriksaLagi()}
                />
              </div>
              <div className="flex flex-none w-full md:max-w-[200px] px-0 md:px-0">
                <Button label="Selesai" onClick={() => handleSelesai()} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </LayoutScreen>
  );
};

export default PageAnalisa;
